module.exports = __webpack_public_path__ + "fonts/600-normal-cyrillic.4514fa0.woff2";